/* eslint-disable */
import {
  cardTitle,
  grayColor,
  warningColor,
} from "assets/jss/material-dashboard-pro-react.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
// eslint-disable-next-line no-unused-vars
import zIndex from "@material-ui/core/styles/zIndex";
// eslint-disable-next-line no-unused-vars
import { boxShadow } from "assets/jss/material-dashboard-pro-react";

const initiativeManagementStyle = (theme, clientColor) => ({
  ...customSelectStyle(theme, clientColor),
  ...customInputStyle(clientColor),

  drawerPaper: {
    width: "1000px", // Defina a largura do Drawer
    maxHeight: "100vh", // Limite a altura ao tamanho da tela
    overflowY: "auto", // Permite rolagem vertical
    padding: theme.spacing(2), // Adicione um espaçamento interno
  },

  drawerTasks: {
    width: "700px", // Defina a largura do Drawer
    maxHeight: "100vh", // Limite a altura ao tamanho da tela
    overflowY: "auto", // Permite rolagem vertical
    padding: theme.spacing(2), // Adicione um espaçamento interno
  },

  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  cardButton: {
    padding: "0 !important",
    margin: "15px 15px 0 10px !important",
    height: "24px !important",
    width: "32px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
    backgroundColor: clientColor + " !important",
    "&.MuiButton-root": {
      cursor: "pointer", // Aplica o cursor especificamente ao botão Material-UI
    },
  },
  cardButtonNoMargin: {
    padding: "0 !important",
    //margin: "15px 15px 0 10px !important",
    height: "24px !important",
    width: "32px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
    backgroundColor: clientColor + " !important",
    "&.MuiButton-root": {
      cursor: "pointer", // Aplica o cursor especificamente ao botão Material-UI
    },
  },

  cardButtonIcon: {
    margin: "0 !important",
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%)",
    width: "18px !important",
    height: "18px !important",
    color: "#FFFFFF",
  },

  actionDisabled: {
    opacity: "0.5 !important",
    pointerEvents: "none",
  },

  toolTipRole: {
    fontSize: "1.1em",
    fontWeight: "bold",
  },
  toolTipDescription: {
    paddingLeft: "1em",
    display: "block",
    fontWeight: "100 !important",
  },

  "@keyframes loadingAnimation": {
    "0%": { backgroundColor: grayColor[4] },
    "25%": { backgroundColor: grayColor[3] },
    "50%": { backgroundColor: grayColor[4] },
    "75%": { backgroundColor: grayColor[3] },
    "100%": { backgroundColor: grayColor[4] },
  },
  loadingAnimation: {
    animation: "$loadingAnimation 4.0s ease-in-out infinite",
  },

  selectFormControlOverride: {
    margin: "3px 0 5px 0 !important",
    paddingTop: "1px",
    paddingBottom: "1px",
    "& > div": {
      "&:before": {
        borderBottomWidth: "0.8px !important",
      },
    },
  },

  tableHeadCell: {
    fontWeight: "300",
    fontSize: "15px",
  },
  tableBodyCell: {
    fontSize: "12px !important",
    fontWeight: "300",
    borderBottom: `1px solid rgba(0, 0, 0, 0.05)`,
  },
  compactTable: {
    "& .MuiTableCell-root": {
      padding: "1px 1px !important",
      lineHeight: "0.1 !important",
      height: "5px !important",
      //overflow: "hidden",
    },
    "& .MuiTableRow-root": {
      height: "40px",
    },
  },
  tableSpinner: {
    height: "100%",
    paddingTop: "4px",
    "& > svg": {
      width: "40px !important",
    },
  },

  attention: {
    backgroundColor: warningColor[0] + " !important",
    animation: "$attention 3s ease infinite",
  },
  "@keyframes attention": {
    "10%": {
      transform: "scale(1.1)",
    },
    "13.33%,20%": {
      transform: "rotate(-10deg) scale(1.1)",
    },
    "16.67%": {
      transform: "rotate(10deg) scale(1.1)",
    },
    "23.33%": {
      transform: "rotate(0deg) scale(1.1)",
    },
    "33%": {
      transform: "scale(1)",
    },
  },

  actionIconsCustom: {
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "center",
    alignItems: "center",
  },
  iconButtonCustom: {
    cursor: "pointer",
    "&:hover": {
      color: clientColor,
    },
  },
  clickableInitiative: {
    cursor: "pointer", // Indica que é clicável
    color: theme.palette.primary.main, // Cor primária para destacar
    textDecoration: "underline", // Estilo de link
    "&:hover": {
      color: clientColor, // Muda a cor ao passar o mouse
    },
  },
  actionColumn: {
    textAlign: "center",
    verticalAlign: "middle",
  },

  searchIcon: {
    color: grayColor[1],
    fontSize: "1.3rem",
  },
  table: {
    //tableLayout: "fixed", // Define layout fixo
    //width: "100%",
    padding: "0 0 0 0", // Faz a tabela ocupar 100% do espaço disponível
    //minWidth: "1300px",
  },
  tableCell: {
    //textAlign: "left",
    padding: "8px",
    paddingLeft: "16px",
    //overflow: "hidden", // Garante que o conteúdo não ultrapasse a célula
    textOverflow: "ellipsis", // Adiciona reticências caso o texto seja muito longo
    whiteSpace: "nowrap", // Impede quebra de linha dentro da célula
    //minWidth: "400px",
  },
  tableCellNoBorder: {
    //textAlign: "left",
    padding: "8px",
    paddingLeft: "16px",
    overflow: "hidden", // Garante que o conteúdo não ultrapasse a célula
    textOverflow: "ellipsis", // Adiciona reticências caso o texto seja muito longo
    whiteSpace: "nowrap", // Impede quebra de linha dentro da célula
    //minWidth: "400px",
    borderBottom: "none",
  },

  tableHeaderIcon: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px", // Espaçamento preciso entre texto e ícone
  },
  sortIcon: {
    fontSize: "14px",
    marginLeft: "4px",
    color: "#ccc",
  },
  activeSortIcon: {
    color: "#aaa",
  },

  textFieldRoot: {
    //padding: "5px 10px",
    "& .MuiInput-underline:before": {
      borderBottom: "1px solid #ccc", // Cor padrão da borda inferior
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: `2px solid ${clientColor}`, // Cor ao passar o mouse
    },
    "& .MuiInput-underline:after": {
      borderBottom: `2px solid ${clientColor}`, // Cor quando selecionado
    },
  },
  inputText: {
    color: "#3C4858", // Cor do texto padrão
    "&:focus": {
      color: "#3C4858", // Cor do texto quando selecionado
    },
  },
  labelText: {
    color: "#666", // Cor padrão do label
    "&.Mui-focused": {
      color: "#666", // Cor do label quando focado
    },
  },
  insideMenu: {
    width: "180px",
    //backgroundColor: grayColor[8],
    borderRadius: "6px",
    marginRight: "16px",
    padding: "10px",
  },
  insideMenuFont: {
    marginBottom: "10px",
    fontSize: "18px",
    cursor: "pointer",
    fontWeight: "300", // valor default
    color: grayColor[1],
    padding: "2px 0px 2px 7px",
  },
  insideMenuFontActive: {
    fontWeight: "500",
    fontSize: "18px",
    color: grayColor[1],
    backgroundColor: grayColor[5],
    borderRadius: "2px",
    padding: "2px 0px 2px 7px",
  },
  selectedInitiativeContainer: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "10px",
  },
  sessionHeader: {
    backgroundColor: grayColor[9],
    borderRadius: "8px 8px 0 0",
    textAlign: "center",
    padding: "5px 8px",
    margin: "-10px -10px 10px",
  },
  sessionHeaderTitle: {
    margin: 0, // remove a margem padrão do h4
    fontWeight: 400, // realçar
    fontSize: "1.25rem", // ou o tamanho que preferir
  },
  initiativeDetailsHeader: {
    textAlign: "center",
    paddingBottom: "5px",
    paddingTop: "5px",
    fontWeight: 400,
    fontSize: "14px",
    backgroundColor: "#FAFAFA",
    color: "#B9B9B9",
    margin: 0,
    borderRadius: "5px",
  },
  approvalDiv: {
    display: "block",
    flexWrap: "wrap",
    gap: "12px",
    //justifyContent: "space-between",
  },
  approvalCard: {
    //flex: "1 1 calc(30% - 20px)",
    flex: 1,
    maxWidth: "260px",
    minWidth: "180px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    padding: "12px",
    backgroundColor: "#fff",
    marginBottom: "6px",
  },
  approvalCardTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #f0f0f0",
    paddingBottom: "8px",
    marginBottom: "12px",
  },
  approvalCardHeaderText: {
    margin: 0,
    fontSize: "13px",
    color: "#333",
    fontWeight: "bold",
  },
  approvalCardHeaderStatus: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
  },
  approvalCardHeaderIcon: {
    color: "white",
    fontSize: "12px",
  },
  approverPhoto: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: "#ddd",
    marginRight: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#555",
  },
  approverName: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "normal",
    marginBottom: "4px",
  },
  approverStatusIcon: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    marginRight: "8px",
  },
  floatingCard: {
    position: "fixed",
    top: 0, // ajusta conforme seu header
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1200,
    backgroundColor: clientColor,
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    borderRadius: "0 0 8px 8px",
    padding: "6px 4px 4px 10px",
    alignItems: "center",
    gap: "10px",
    maxWidth: "90%", // Em telas pequenas, até 90% da largura
    [theme.breakpoints.down("sm")]: {
      // Em telas < sm, empurra um pouco para a direita
      position: "static",
      alignItems: "center",
      maxWidth: "100%",
      transform: "none",
      zIndex: 1200,
      borderRadius: 0, // se quiser remover arredondamento em mobile
      margin: "-40px 15px 37px 0",
      backgroundColor: "#EEEE",
      borderBottom: "1px solid " + grayColor[4],
      boxShadow: "none",
    },
  },
  expandAdvancedFilters: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    color: "#666",
    padding: "0px 7px 4px 0px",
    margin: "-1px 7px 4px -7px",
    border: "none",
    minWidth: 0,
    boxShadow: "none",
    backgroundColor: "transparent !important",
    flexShrink: 0,
  },
  clearFilters: {
    position: "absolute",
    bottom: "1px", // Ajusta a posição vertical
    right: "13px", // Ajusta a posição horizontal
    backgroundColor: "transparent",
    color: "#666",
    fontSize: "10px",
    fontWeight: "bold",
    borderRadius: "50%",
    width: "10px",
    height: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  clearFiltersImp: {
    position: "absolute",
    bottom: "13px", // Ajusta a posição vertical
    right: "13px", // Ajusta a posição horizontal
    backgroundColor: "transparent",
    color: "#666",
    fontSize: "10px",
    fontWeight: "bold",
    borderRadius: "50%",
    width: "10px",
    height: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  outlinedInput: {
    "&.MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc", // Cor da borda padrão
        padding: "20px 20px 20px 20px",
      },
      "&:hover fieldset": {
        borderColor: "#666", // Cor da borda ao passar o mouse
      },
      "&.Mui-focused fieldset": {
        borderColor: clientColor, // Cor da borda quando focado
        borderWidth: "1.5px",
        boxShadow: "7px 3px 7px 3px rgba(0,0,0,0.05)",
      },
    },
    "& input": {
      padding: "7px 7px", // Ajuste o espaçamento interno do campo para evitar cortes
    },
  },

  outlinedInputv2: {
    "&.MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc", // Cor da borda padrão
        padding: "5px 5px 5px 5px",
      },
      "&:hover fieldset": {
        borderColor: "#666", // Cor da borda ao passar o mouse
      },
      "&.Mui-focused fieldset": {
        borderColor: clientColor, // Cor da borda quando focado
        borderWidth: "1.5px",
        boxShadow: "7px 3px 7px 3px rgba(0,0,0,0.05)",
      },
    },
    "& input": {
      padding: "7px 7px", // Ajuste o espaçamento interno do campo para evitar cortes
    },
  },

  autocompleteRoot: {
    minWidth: "180px",
    "& .MuiOutlinedInput-root": {
      //borderRadius: "10px", // Bordas arredondadas
      padding: "5px", // Espaçamento interno
    },
  },
  inputRoot: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc", // Cor da borda padrão
      borderWidth: "1px", // Largura padrão da borda
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc", // Cor da borda ao passar o mouse
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc", // Cor da borda quando focado
      borderWidth: "2px", // Largura da borda quando focado
    },
    "& .MuiInputBase-input::placeholder": {
      color: grayColor[2], // Cor do placeholder
      fontSize: "12px", // Tamanho da fonte do placeholder
      fontStyle: "italic", // Texto em itálico
    },
  },
  option: {
    fontSize: "12px", // Tamanho da fonte das opções
    padding: "8px", // Espaçamento interno das opções
    "&:hover": {
      backgroundColor: theme.palette.action.hover, // Cor de fundo ao passar o mouse
    },
    "&[aria-selected='true']": {
      backgroundColor: clientColor, // Fundo da opção selecionada
      color: "#fff", // Texto da opção selecionada
    },
  },
  paper: {
    borderRadius: "4px", // Bordas arredondadas no dropdown
    boxShadow: theme.shadows[5], // Sombra do dropdown
  },
  cardOnePage: {
    marginBottom: "20px",
    border: "0.2px solid #eee",
    borderLeft: `6px solid ${clientColor}`,
  },
  alertApproval: {
    border: `1px solid ${clientColor}`,
    borderRadius: "4px",
  },
  tabsRoot: {
    backgroundColor: "#f5f5f5",
    padding: 0,
    margin: 0,
    //boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    // Definindo minHeight e height diretamente no componente Tabs
    minHeight: "42px",
    height: "42px",
    flex: 0.7,
    "& .MuiTabs-flexContainer": {
      minHeight: "42px",
      height: "42px",
    },
  },
  indicator: {
    backgroundColor: clientColor,
    height: "1.5px",
  },
  tabRoot: {
    margin: 0,
    padding: 0,
    fontSize: "0.7rem",
    fontWeight: 400,
    color: "black",
    textTransform: "uppercase",
    "&:hover": {
      color: clientColor,
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "black",
      fontWeight: 500,
      borderBottom: `2px solid ${clientColor}`,
    },
    "&:focus": {
      color: "black",
    },
    "&.Mui-disabled": {
      // <-- Estiliza a aba quando está desabilitada
      color: "gray !important", // Cor cinza para parecer desativada
      cursor: "not-allowed", // Cursor de "proibido" para reforçar que está desativada
      opacity: "0.3 !important", // Reduz opacidade para visualmente indicar que está inativa
    },
  },

  summaryCardInitiative: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    boxShadow: "none",
    flex: 1,
    minHeight: "30px",
    borderLeft: `3px solid ${clientColor}`,
    borderRight: `3px solid ${clientColor}`,
    //boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
    borderRadius: "8px",
    padding: "16px",
    backgroundColor: "#fff",
  },

  summaryCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    boxShadow: "none",
    flex: 1,
    minHeight: "117px",
    borderLeft: `3px solid ${clientColor}`,
    borderRight: `3px solid ${clientColor}`,
    //boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
    borderRadius: "8px",
    padding: "16px",
    backgroundColor: "#fff",
  },

  summaryResource: {
    display: "flex-start",
    alignItems: "left",
    justifyContent: "space-around",
    boxShadow: "none",
    flex: 1,
    minHeight: "112px",
    borderLeft: `3px solid ${clientColor}`,
    borderRight: `3px solid ${clientColor}`,
    borderRadius: "8px",
    backgroundColor: "#fff",
  },

  circleIndicator: {
    height: "30px",
    width: "30px",
    borderRadius: "50%",
    display: "inline-block",
  },
  filterContainer: {
    display: "flex",
    gap: "16px",
    marginBottom: "12px",
    flexWrap: "wrap",
  },
  filterItem: {
    minWidth: 140,
  },
  // Board
  boardContainer: {
    display: "grid",
    gap: "15px",
    overflowX: "auto",
  },
  boardColumn: {
    backgroundColor: "#f5f5f5",
    borderRadius: 6,
    boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
    padding: "10px",
    minHeight: 300,
    width: 250,
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },

  boardColumnHeader: {
    marginBottom: "10px",
    fontWeight: 600,
    borderBottom: "1px solid #e0e0e0", // linha sutil
    paddingBottom: "5px",
  },
  cardItem: {
    backgroundColor: "#fafafa", // Cinza bem claro para se destacar do fundo branco
    borderRadius: 4,
    marginBottom: 10,
    padding: 8,
    cursor: "pointer",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)", // Sombra sutil para dar profundidade
    border: "1px solid #e0e0e0", // Borda sutil
  },

  chipDefault: {
    backgroundColor: grayColor[5], // Cinza claro para o estado padrão
    color: theme.palette.text.primary,
  },
  chipSelected: {
    backgroundColor: clientColor, // Cor principal para o selecionado
    color: "#fff",
    "&:hover": {
      backgroundColor: clientColor,
    },
    "&:focus": {
      backgroundColor: clientColor,
    },
    "&:active": {
      backgroundColor: clientColor,
    },
  },
  fullScreen: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "#fff",
    zIndex: 1300,
    overflow: "auto",
    padding: theme.spacing(2),
  },
  chartContainer: {
    height: "250px",
    marginTop: theme.spacing(2),
  },
  ganttMaster: {
    maxHeight: 450,
    overflowY: "auto",
    overflowX: "auto", // scroll X para todo o conjunto
    position: "relative",
    border: "1px solid #ccc",
    fontFamily: "Roboto",
  },
  ganttTable: {
    background: "#fff",
    zIndex: 3,
    borderRight: "1px solid #ddd",
    minWidth: 300,
  },
  ganttTableHeader: {
    position: "sticky", // Fixa o cabeçalho no topo ao rolar verticalmente
    top: 0,
    zIndex: 5,
    backgroundColor: "#f1f1f1",
  },
  ganttTableColumns: {
    padding: "8px",
    borderRight: "1px solid #ddd",
    textAlign: "left",
    fontWeight: 500,
    fontSize: "13px",
    fontFamily: "Roboto",
    cursor: "pointer",
  },
  ganttTableBody1st: {
    padding: "4px 8px",
    borderRight: "1px solid #ddd",
    cursor: "pointer",
    textAlign: "left",
    fontWeight: 400,
    fontSize: "11px",
    fontFamily: "Roboto",
    color: "#333",
  },
  ganttTableBody: {
    padding: "4px 8px",
    borderRight: "1px solid #ddd",
    textAlign: "center",
    fontWeight: 400,
    fontSize: "11px",
    fontFamily: "Roboto",
    color: "#333",
  },
  ganttTimeline: {
    position: "sticky",
    top: 0,
    zIndex: 5,
    display: "flex",
    backgroundColor: "#f0f0f0",
    borderBottom: "1px solid #ddd",
    fontSize: "13px",
    fontWeight: 500,
  },
  ganttTimelineFormat: {
    borderRight: "1px solid #eee",
    textAlign: "center",
    fontSize: "10px",
    padding: "2px",
    height: "37px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  toggleGanttDataFilter:{
    paddingTop: -7, 
    paddingBottom: -7, 
    fontSize:"9px", 
    border: "none",
    borderRadius: "0px",
    color: "#3C4858",
  },
  accordionRootCustom: {
    marginBottom: 5,
    overflow: "hidden",
    border: `1px dotted ${clientColor}`,
    boxShadow: "none", // Remove a sombra
    "&:before": {
      display: "none", // Remove a linha antes do Accordion (se houver)
    },
    // Primeiro Accordion
    "&:first-of-type": {
      borderRadius: "10px 10px 10px 10px",
    },
    // Segundo Accordion (caso específico do 'meio')
    "&:nth-of-type(2)": {
      borderRadius: "10px 10px 10px 10px",
    },
    // Terceiro (ou último) Accordion
    "&:last-of-type": {
      borderRadius: "10px 10px 10px 10px",
    },
  },

  helperText: {
    fontSize: "9px",
    fontStyle: "italic",
  },

  slider: {
    width: 220,
    color: clientColor,
    marginTop: "-9px",
    "& .MuiSlider-thumb": {
      width: 10,
      height: 10,
      backgroundColor: "white",
      border: "2px solid #5555",
      marginTop: "-3px",
    },
    "& .MuiSlider-track": {
      height: 4,
    },
    "& .MuiSlider-rail": {
      height: 4,
      backgroundColor: "#ddd",
    },
    "& .MuiSlider-markLabel": {
      fontSize: "10px",
      color: "#666",
      marginTop: "-6px",
    },
  },
  ellipsisText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 180,          // mesma largura do card
  },
});

export default initiativeManagementStyle;
